module.exports = "https://infinity-call.servercdn.it/static/img/left.jpg?9631dfbb7fe020e7748b833687527eff";